import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FastForwardIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M3 20V4L13 11.5L3 20Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M11 20V4L21 11.5L11 20Z",
    fill: "currentColor"
  }));
}